import React from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Roles from './Roles/Roles';
import RequestType from './RequestType/RequestType';
import Urgency from './Urgency/Urgency';
import Impact from './Impact/Impact';
import Priority from './Priority/Priority';
import ResolverGroup from './ResolverGroup/ResolverGroup';
import Resolver from './Resolver/Resolver';
import OrgTab from './Org/OrgTab';
import RolesTab from './Roles/RolesTab';
import SLAs from './SLA/SLAs';

const Admin = () => {
    
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Org's" value="1" />
                <Tab label="Role" value="2" />
                <Tab label="SLA" value="3" />
                {/* <Tab label="Req Type" value="4" />
                <Tab label="Urgency" value="5" />
                <Tab label="Impact" value="6" />
                <Tab label="Priority" value="7" />
                <Tab label="Status" value="8" />
                <Tab label="Res Group" value="9" />
                <Tab label="Resolver" value="10" />  */}
                {/* <Tab label="Department" value="11" />  */}
              </TabList>
            </Box>
                <TabPanel value="1">                
                  <OrgTab/>
                </TabPanel>
                
                <TabPanel value="2"><RolesTab/>
                </TabPanel>

                <TabPanel value="3"><SLAs />
                </TabPanel>
                
                {/* <TabPanel value="4"><RequestType/>
                </TabPanel>
                
                <TabPanel value="5"><Urgency/>
                </TabPanel>
                
                <TabPanel value="6"><Impact/>
                </TabPanel>
                
                <TabPanel value="7"><Priority/>
                </TabPanel>
                
                <TabPanel value="8"><Status/>
                </TabPanel>
                
                <TabPanel value="9"><ResolverGroup/>
                </TabPanel>
                
                <TabPanel value="10"><Resolver/>
                </TabPanel> */}

                {/* <TabPanel value="11">
                <Department/>
                </TabPanel> */}
                
            </TabContext>
            </Box>
    );
  };
  
  export default Admin;